import {Card, CardContent, CardDescription, CardHeader, CardTitle} from '@orbit-ui/components/card';
import {PageHeader} from '@orbit-ui/components/page-header';

export const EnvironmentsOverviewView = () => (
  <div className="container mx-auto space-y-6 py-6">
    <PageHeader title="Environments Overview" description="Manage your cloud environments" />

    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      <Card>
        <CardHeader>
          <CardTitle>Production</CardTitle>
          <CardDescription>Production Environment</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm">Status: Active</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Staging</CardTitle>
          <CardDescription>Staging Environment</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm">Status: Active</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Development</CardTitle>
          <CardDescription>Development Environment</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm">Status: Active</p>
        </CardContent>
      </Card>
    </div>
  </div>
);
